module.exports = __webpack_public_path__ + "files/8723aaa6b4fb4a56e67439d5b8002ce4.png";